export const api = process.env.REACT_APP_API || `https://api.mmapp.pl/v1/`
const mobile = `${api}clients/mobile/`

export const config = `${api}client/config`
export const categories = `${api}categories`
export const checkPrice = `${api}checkPrice`
export const locations = `${api}locations`
export const mapFilters = `${api}mapfilters`
export const mapLocations = `${api}maplocations`
export const additional = `${api}additional`
export const insurance = `${api}insurance`
export const mapfilters = `${api}mapfilters`
export const locationRequest = `${api}locationrequest`
export const webpushdevices = `${api}webpushdevices`
export const mycallservices = `${api}mycallservices`
export const usernotifications = `${api}usernotifications`
export const warehousespermissions = `${api}warehousespermissions`
export const warehousepermissions = `${api}warehousepermissions`
export const contractresignationreasons = `${api}contractresignationreasons`
export const getsharedinfo = `${api}getsharedinfo`
export const findCompany = `${api}company/find/`
export const warehousenotify = `${api}warehousenotify`

export const passwordForgot = `${api}password/forgot`
export const passwordReset = `${api}password/reset`
export const preregister = `${api}preregister`
export const refresh = `${mobile}refresh`
export const register = `${api}register`
export const login = `${mobile}login`
export const logout = `${api}logout`

export const cart = `${api}cart`
export const shopproducts = `${api}shopproducts`
export const shopcategories = `${api}shopcategories`
export const contracts = `${api}contracts/getlockinfo`
export const openingmethodoptions = `${api}openingmethodoptions`
export const contractresignations = `${api}contractresignations`
export const contractAccess = contractId => `${api}contracts/${contractId}/access`
export const contractExtend = contractId => `${api}contracts/${contractId}/extend`
export const contractResignation = contractId => `${api}contracts/${contractId}/resignation`
export const warehousesAction = `${api}warehouses/action`

const payment = `${api}payment/`
export const paymentSettlement = `${payment}settlement`
export const paymentMethod = `${payment}methods`
export const paymentStatus = `${payment}status`
export const paymentCompletedStatus = `${payment}completed/status`

export const verify = (type = 'device') => `${api}${type}/verify`

export const removeDevice = `${api}userdevices/`
export const removePaymentMethods = `${api}userpaymentmethods/`

export const checkAddress = `${api}checkaddress`
export const checkAvailability = placeID => `${api}places/${placeID}/checkavailability`
export const announcement = placeID => `${api}places/${placeID}/announcement`
export const delivery_points = `${api}couriers/delivery_points`

export const webauthn = `https://api.mmapp.pl/webauthn/`
export const authProtected = `${api}protected`

export const user = `${api}user`
export const userInfo = `${user}/info`
export const userBalance = `${user}/balance`
export const devices = `${user}/devices`
export const userConfig = `${user}/config`
export const invoices = `${user}/invoices`
export const companies = `${user}/companies`
export const favorites = `${user}/favorites`
export const shortcuts = `${user}/shortcuts`
export const sharings = `${user}/sharings`
export const newsmscode = `${user}/newsmscode`
export const newmailcode = `${user}/newemailcode`
export const events = `${user}/rentedreserved/events`
export const paymentmethods = `${user}/paymentmethods`
export const getobjectstates = `${api}warehouses/getobjectstates`
export const warehouses = (userId = '') => `${api}users/${userId}/warehouses/rentedreserved`

export const updateCompanies = `${api}companies`
export const companiesFields = `${api}getfields/companies`
